import { Box, BoxProps, SxProps } from '@mui/material';
import { CSSProperties, ReactNode } from 'react';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

export interface Props extends BoxProps {
  children: ReactNode;
  sx?: SxProps;
  style?: CSSProperties;
  className?: string;
  shadow?: boolean;
}

const WhiteContainer: React.FC<Props> = ({ children, shadow, sx, style, className = "", ...boxProps }) => {

  const accessibility = useAccessibility();

  const mandatoryStyles: CSSProperties = {
    backgroundColor: accessibility.contrastMode ? '#000' : '#fff',
    border: accessibility.contrastMode ? '1px solid white' : '1px',
    borderRadius: '8px',
  }

  const shadowStyle: CSSProperties = {
    border: 'solid 1px #EEEEEE',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)'
  }

  return (
    <Box
      style={{ ...style, ...mandatoryStyles, ...(shadow ? shadowStyle : undefined) }}
      sx={sx}
      className={className}
      {...boxProps}
    >
      {children}
    </Box>
  )
}

export default WhiteContainer;